import { resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createVNode as _createVNode, normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, withModifiers as _withModifiers, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-c3136714"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "flex items-center justify-end pb-4 px-3" }
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "fas fa-search mr-2" }, null, -1))
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "fas fa-undo mr-2" }, null, -1))

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_new_input = _resolveComponent("new-input")!
  const _component_new_select = _resolveComponent("new-select")!
  const _component_new_button = _resolveComponent("new-button")!

  return (_openBlock(), _createElementBlock("form", {
    class: "CrmWhatsappFilters",
    onSubmit: _cache[7] || (_cache[7] = _withModifiers(
//@ts-ignore
(...args) => (_ctx.onFiltersChanged && _ctx.onFiltersChanged(...args)), ["prevent"]))
  }, [
    _createElementVNode("div", {
      class: _normalizeClass(["CrmWhatsappFilters__container", { 'grid-cols-4': !_ctx.isChat, 'grid-cols-3': _ctx.isChat }])
    }, [
      (!_ctx.isChat)
        ? (_openBlock(), _createBlock(_component_new_input, {
            key: 0,
            placeholder: "Номер телефона",
            disabled: _ctx.loading,
            value: _ctx.state.phoneNumber,
            "onUpdate:value": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.state.phoneNumber) = $event))
          }, null, 8, ["disabled", "value"]))
        : _createCommentVNode("", true),
      _createVNode(_component_new_input, {
        placeholder: "Кто последний ответил",
        disabled: _ctx.loading,
        value: _ctx.state.senderName,
        "onUpdate:value": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.state.senderName) = $event))
      }, null, 8, ["disabled", "value"]),
      (!_ctx.isChat)
        ? (_openBlock(), _createBlock(_component_new_input, {
            key: 1,
            placeholder: "Номер накладной",
            disabled: _ctx.loading,
            value: _ctx.state.invoiceNumber,
            "onUpdate:value": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.state.invoiceNumber) = $event))
          }, null, 8, ["disabled", "value"]))
        : _createCommentVNode("", true),
      (!_ctx.isChat)
        ? (_openBlock(), _createBlock(_component_new_input, {
            key: 2,
            placeholder: "Номер заказа",
            disabled: _ctx.loading,
            value: _ctx.state.orderNumber,
            "onUpdate:value": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.state.orderNumber) = $event))
          }, null, 8, ["disabled", "value"]))
        : _createCommentVNode("", true),
      (!_ctx.isChat)
        ? (_openBlock(), _createBlock(_component_new_select, {
            key: 3,
            "can-deselect": "",
            placeholder: "Шаблон",
            loading: _ctx.data_state.settings.is_loading,
            failed: _ctx.data_state.settings.is_failed,
            disabled: _ctx.loading,
            "search-without-refresh": "",
            options: _ctx.data_state.settings.list,
            value: _ctx.state.typeId,
            "onUpdate:value": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.state.typeId) = $event)),
            label: "title",
            onRefresh: _ctx.loadSettings
          }, null, 8, ["loading", "failed", "disabled", "options", "value", "onRefresh"]))
        : _createCommentVNode("", true),
      _createVNode(_component_new_input, {
        placeholder: "Дата с",
        type: "date",
        disabled: _ctx.loading,
        value: _ctx.state.createdAtFrom,
        "onUpdate:value": _cache[5] || (_cache[5] = ($event: any) => ((_ctx.state.createdAtFrom) = $event))
      }, null, 8, ["disabled", "value"]),
      _createVNode(_component_new_input, {
        placeholder: "Дата по",
        type: "date",
        disabled: _ctx.loading,
        value: _ctx.state.createdAtTo,
        "onUpdate:value": _cache[6] || (_cache[6] = ($event: any) => ((_ctx.state.createdAtTo) = $event))
      }, null, 8, ["disabled", "value"])
    ], 2),
    _createElementVNode("div", _hoisted_1, [
      _createVNode(_component_new_button, {
        disabled: _ctx.loading || _ctx.disabled,
        class: "NewButton--search mr-3",
        type: "submit"
      }, {
        default: _withCtx(() => [
          _hoisted_2,
          _createTextVNode(" Поиск ")
        ]),
        _: 1
      }, 8, ["disabled"]),
      _createVNode(_component_new_button, {
        disabled: _ctx.loading || _ctx.disabled,
        class: "NewButton--reset",
        onClick: _ctx.onFiltersReset
      }, {
        default: _withCtx(() => [
          _hoisted_3,
          _createTextVNode(" Сбросить ")
        ]),
        _: 1
      }, 8, ["disabled", "onClick"])
    ])
  ], 32))
}